export default __webpack_public_path__ + "static/media/icon_chevron_more.dc70d3dd.svg";